import { GET_PRIVATE_PERSONAL_DATA } from 'constants/private-data';

const initialState = {
  isFetching: false,
  data: {},
  error: null,
};

export const personalDataReducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case `${GET_PRIVATE_PERSONAL_DATA}_PENDING`: {
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    }
    case `${GET_PRIVATE_PERSONAL_DATA}_FULFILLED`: {
      return {
        ...state,
        isFetching: false,
        data: payload,
        error: null,
      };
    }
    case `${GET_PRIVATE_PERSONAL_DATA}_REJECTED`: {
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};
